import React from "react";

const STATUS_CLASS_MAP = {
  active: "profit-status-ok",
  ready: "profit-status-ok",
  enabled: "profit-status-ok",
  pending: "profit-status-warn",
};

export default function ProfitStatusBadge({ status, label }) {
  const normalizedStatus = String(status || "").toLowerCase();
  const className = STATUS_CLASS_MAP[normalizedStatus] || "profit-status-error";

  return (
    <span className={"profit-status " + className}>
      <span className="profit-status-dot" />
      {label || status}
    </span>
  );
}
